// import React, {memo} from "react";
import { useState, useEffect } from "react";
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useRef } from "react";

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";
import { Modal, Radio, Button } from 'antd';
import UserAlerts from "../../components/UserAlerts";

const LoanDecisionModal = ({application, applicationDecision, isModalOpen, setIsModalOpen}) => {

    const [error, setError] = useState('');
    const errorRef = useRef(null);

    // const params = useParams()
    const queryClient = useQueryClient();

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    // const {fetchData, data, response}  = useAxios();
    // const { data:customerData, fetchData:fetchCustomerData}  = useAxios();   

    const client = localStorage.getItem('clientID');
    const user = localStorage.getItem('userID');

    const [approvedAmount, setApprovedAmount] = useState(application?application.amount:"");
    const [term, setTerm] = useState(application?application.term:""); 
    const [interestRate, setInterestRate] = useState("");
    const [loanDecision, setLoanDecision] = useState("10");
    const [memo, setMemo] = useState("");

    const navigate = useNavigate();

    const mutation = useMutation({
        mutationFn: (applicationData) => {
            console.log(application)
            const action = applicationDecision === 'APPROVE' ? 'approve' : 'decline';
            return authAxios.patch(`/loans/loan-applications/${application.id}/${action}/`, applicationData);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(['applications']);
            queryClient.refetchQueries(['applications']);
            setIsModalOpen(false);
            navigate('/dashboard/applications/');
        },
      })

    const handleSubmit = (e) => {
        e.preventDefault();

        // For approval we send full approval details; for decline we send a minimal payload (reason + user)
        if (applicationDecision === 'APPROVE') {
            const amount = parseFloat(approvedAmount.replace(/,/g, ''));
            const interest_rate = parseFloat(interestRate.replace(/,/g, '')) / 100;
            const applicationData = { client, amount, term, interest_rate, memo, user };
            console.log('Submitting approval:', applicationData)
            mutation.mutate(applicationData)
        } else {
            const applicationData = { client, user, memo };
            console.log('Submitting decline:', applicationData)
            mutation.mutate(applicationData)
        }
    }


    useEffect(() => {
        if (application){
            setApprovedAmount(application.amount)
            setTerm(application.term)
            setInterestRate(application.interest_rate*100+"")
        }
    }, [application]);


    // console.log("Application Decision:", applicationDecision);

    return(
        <>
        {isModalOpen && 
            <Modal 
                className="dashboard-modal" 
                // title="Loan Decision" 
                title={applicationDecision === 'APPROVE' ? "Approve Loan" : "Decline Loan"}
                visible={isModalOpen} 
                open={isModalOpen} 
                // onOk={handleSubmit} 
                onCancel={handleCancel}
                // confirmLoading={mutation.isLoading || mutationManagementFee.isLoading}
                footer={[
                  <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                  <Button key="submit" type="primary" loading={mutation.isLoading} onClick={handleSubmit}>
                    {/* Submit */}
                    {applicationDecision === 'APPROVE' ? "Approve" : "Decline"}
                  </Button>
                ]}
            >
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                 



                        <TextField className="custom-input"
                            value={application?application.customer_name:""}
                            label="Name" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />

                        <TextField className="custom-input"
                            value={application?application.product_name:""}
                            label="Product" 
                            variant="outlined" 
                            fullWidth
                            disabled
                        />
                        <div style={{display: 'flex', gap: '10px'}}>
                            <NumberFormat   
                                value={application?application.amount:""}
                                className="custom-input"
                                fullWidth
                                label="Principal" 
                                variant="outlined" 
                                customInput={TextField}
                                decimalScale={0}
                                fixedDecimalScale
                                decimalSeparator="."
                                isNumericString
                                thousandSeparator={true} 
                                disabled
                            />
                            <TextField className="custom-input"
                                value={application?application.term+""+application.term_unit_name:""}
                                label="Term" 
                                variant="outlined" 
                                fullWidth
                                disabled
                            />
                        </div>
                        
                        {applicationDecision === 'APPROVE' &&
                        <>
                            <div style={{display: 'flex', gap: '10px'}}>
                                <NumberFormat   
                                    value={approvedAmount}
                                    onChange={(e) => setApprovedAmount(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Approved Amount" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    decimalScale={0}
                                    fixedDecimalScale
                                    decimalSeparator="."
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 
                                />

                                <NumberFormat   
                                    value={term}
                                    onChange={(e) => setTerm(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Approved Term" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 

                                />
                                <NumberFormat   
                                    value={interestRate}
                                    onChange={(e) => setInterestRate(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Interest Rate" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix="%"
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 

                                />
                        
                            </div>
                        </>
                        }

                        <TextField className="custom-input"
                            onChange={(e) => {
                                setMemo(e.target.value)
                            }}
                            label="Comments"
                            variant="outlined"
                            multiline
                            rows={2}
                            fullWidth
                        />
          

                    </form>
                </div>
            </Modal>
        }
        </>

    )

}

export default LoanDecisionModal;

